import { Reducer } from 'redux';
import {
    CARRIERS_LOAD_START,
    CARRIERS_LOAD_SUCCESS,
    CARRIERS_LOAD_FAILURE,
    CarriersActions,
} from '../actions/carriersActions';
import { IAsynchronouslyLoadedValue, CarriersMap } from '../types';

export interface ICarriersState {
    carriers: IAsynchronouslyLoadedValue<CarriersMap>;
}

const initialState: ICarriersState = {
    carriers: {
        status: 'Uninitialized',
    },
};

export const carriersReducer: Reducer<ICarriersState, CarriersActions> = (
    state = initialState,
    action
): ICarriersState => {
    switch (action.type) {
        case CARRIERS_LOAD_START:
            return {
                ...state,
                carriers: {
                    status: 'Loading',
                },
            };
        case CARRIERS_LOAD_SUCCESS:
            return {
                ...state,
                carriers: {
                    status: 'Loaded',
                    value: action.payload,
                },
            };
        case CARRIERS_LOAD_FAILURE:
            return {
                ...state,
                carriers: {
                    status: 'Failed',
                    error: action.payload,
                },
            };
        default:
            return state;
    }
};
